export default (getView) => (nextStepPath) => ({
  ...getView(nextStepPath),

  getButtonState() {
    const { apetite, ratherEat, smoking } = this.formValues

    this.showButton = !!(apetite && ratherEat && smoking)
  },
})
